export const contractTypes = ['CDI', 'CDD', 'Stage', 'Alternance']
